import { render } from "./Azul.vue?vue&type=template&id=9294904e&ts=true"
import script from "./Azul.vue?vue&type=script&lang=ts"
export * from "./Azul.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__